import {
  CirclesThreeIcon,
  ClearIcon,
  cn,
  type CriteriaFilterValue,
  TagIcon,
  Button,
} from "@stacklet/ui";

import { isTagCriteria } from "../utils/criteriaFilterUtils";

const NO_OPERATOR_NAMES = ["policy-name", "binding-uuid"];

interface Props {
  filterValue: CriteriaFilterValue;
  onRemove?: (filterValue: CriteriaFilterValue) => void;
}

export function FilterChip({ filterValue, onRemove }: Props) {
  const isTag = isTagCriteria(filterValue.criteria);
  const isAccountGroup = filterValue.criteria === "account-group-name";

  const displayName = isTag ? filterValue.name : filterValue.criteria;
  const displayValue = filterValue.value?.map((v) => v.name).join(", ") ?? "";

  const hideNameOperator = NO_OPERATOR_NAMES.includes(filterValue.criteria);

  const chipClasses =
    "text-label-small flex gap-x-1 font-normal text-label-small whitespace-nowrap flex-nowrap items-center border border-outline-decorative text-legacy-neutrals-ash rounded-[4px] py-[.15625rem] px-[.5rem]";

  const content = (
    <>
      {isTag ? <TagIcon className="size-icon-s" /> : null}
      {isAccountGroup ? <CirclesThreeIcon className="size-icon-s" /> : null}
      {!hideNameOperator ? (
        isTag ? (
          <span>
            {displayName}{" "}
            <span className="capitalize">
              {filterValue.operator?.replaceAll("-", " ")}
            </span>
          </span>
        ) : (
          <span className="capitalize">
            {displayName?.replaceAll("-", " ")}{" "}
            {filterValue.operator?.replaceAll("-", " ")}
          </span>
        )
      ) : null}
      <b>{displayValue}</b>
    </>
  );

  if (onRemove) {
    return (
      <Button
        IconRight={<ClearIcon className="size-icon-xs text-legacy-navy-L10" />}
        className={cn("hover:border-negative-300", chipClasses)}
        onPress={() => onRemove(filterValue)}
        variant="plain"
      >
        {content}
      </Button>
    );
  }

  return <span className={chipClasses}>{content}</span>;
}
